import React from 'react';
import { dummyClick } from '../../utilities';
import { BlueLink, YellowButton } from '../../buttons';

const StoryActions = ({ subscribe, disabled, readAgain, onSubscribe, onReadAgain }) => (
  <div className="center">
    <YellowButton text={subscribe} onClick={onSubscribe} disabled={disabled} />
    <BlueLink text={readAgain} className="ttu t-ml4" onClick={onReadAgain} />
  </div>
);

StoryActions.defaultProps = {
  subscribe: 'EN Subscribe',
  readAgain: 'EN Read Again',
  onSubscribe: dummyClick,
  onReadAgain: dummyClick
};

export default StoryActions;
